import { emailtemplatesApi } from "api/emailtemplates/emailtemplatesApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useEmailTemplates = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.EMAIL_TEMPLATES(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => emailtemplatesApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.EMAIL_TEMPLATES(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, emailTemplates: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
